export default __webpack_public_path__ + "static/media/ic_target.29bc3345.svg";